import { IPrice } from './../../../buyer/interfaces/IPrice';
export interface OfferItemDetail {
  itemCode: string,
  manufacturerLogoUrl: string,
  description: string,
  availability: number,
  listPrice: number,
  prices?:  IPrice[]
}
